// Аналитика страницы детализации
// Ссылка на документацию: https://docs.google.com/document/d/1iBQBbEzIxpWfhU6damoSyPzu9mkasiH8drhDV5Qa3tM/edit

export const pushDetalizationAnalytics = (event, details) => {
    window?.dataLayer.push({
      event,
      details,
    });
};
